var map = {
	"./agenda": 72046,
	"./agenda.js": 72046,
	"./basicInfo": 7126,
	"./basicInfo.js": 7126,
	"./sponsor": 91274,
	"./sponsor.js": 91274,
	"./users": 23976,
	"./users.js": 23976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79210;